import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Hazard.css";
import Sidebar from "../Components/Sidebar";
import { AlertTriangle, Video, Star, Info, Lock } from "lucide-react";

const Hazard = () => {
  const [hazards, setHazards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const lang = localStorage.getItem("lang") || "en";

  useEffect(() => {
    const fetchHazards = async () => {
      try {
        const token = localStorage.getItem("jwtToken");
        if (!token) throw new Error("Unauthorized. Please log in.");

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/hazards`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.error) {
          setError(response.data.msg);
        } else {
          setHazards(response.data.data);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHazards();
  }, []);

  const getText = (en, bn) => (lang === "bn" ? bn : en);

  const handleHazardClick = (hazard) => {
    if (hazard.show) {
      window.location.href = `/hazard/${hazard.id}`;
    } else {
      setShowModal(true);
    }
  };

  if (loading)
    return (
      <div className="hazard-loading">
        {getText("Loading...", "লোড হচ্ছে...")}
      </div>
    );

  if (error)
    return (
      <div className="hazard-error">
        {getText("Error:", "ত্রুটি:")} {error}
      </div>
    );

  return (
    <div className={`overview ${lang === "bn" ? "bn-font" : ""}`}>
      <Sidebar />
      <div className="hazard-container">
        <div className="hazard-intro">
          <h2>
            <AlertTriangle className="hazard-intro-icon" />{" "}
            {getText("Hazard Perception Test", "হ্যাজার্ড শনাক্তকরণ পরীক্ষা")}
          </h2>
          <div className="hazard-instructions">
            <div>
              <Video className="hazard-icon" />
              {getText(
                "Click on the video when you spot a hazard",
                "ভিডিওতে ক্লিক করুন যখন আপনি একটি হ্যাজার্ড লক্ষ্য করেন"
              )}
            </div>
            <div>
              <Star className="hazard-icon" />
              {getText(
                "Earn up to 5 points per hazard",
                "প্রতি হ্যাজার্ডে সর্বোচ্চ ৫ পয়েন্ট অর্জন করুন"
              )}
            </div>
            <div>
              <AlertTriangle className="hazard-icon" />
              {getText(
                "Avoid pattern clicking",
                "প্যাটার্ন ক্লিকিং এড়িয়ে চলুন"
              )}
            </div>
          </div>
          <div className="hazard-pass-info">
            <Info className="info-icon" />
            {getText(
              "Score 3+ points per hazard to pass",
              "উত্তীর্ণ হতে প্রতি হ্যাজার্ডে ৩+ পয়েন্ট স্কোর করুন"
            )}
          </div>
        </div>

        <div className="hazard-grid">
          {hazards.map((hazard) => (
            <div
              key={hazard.id}
              className={`hazard-card ${!hazard.show ? "locked" : ""}`}
              onClick={() => handleHazardClick(hazard)}
            >
              <img
                src={hazard.thumbnail}
                alt={`Hazard ${hazard.id}`}
                className="hazard-thumbnail"
              />
              <div className="hazard-content">
                <div className="hazard-title">
                  {getText(`Hazard ${hazard.id}`, `হ্যাজার্ড ${hazard.id}`)}
                </div>
                {!hazard.show && <Lock className="hazard-icon" />}
                {hazard.show && <AlertTriangle className="hazard-icon" />}
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="premium-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="premium-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="premium-modal-title">
              {getText("Upgrade to Premium", "প্রিমিয়ামে আপগ্রেড করুন")}
            </h2>
            <p className="premium-modal-text">
              {getText(
                "Unlock all hazard tests by subscribing to the premium plan.",
                "প্রিমিয়াম প্ল্যানে সাবস্ক্রাইব করে সব হ্যাজার্ড টেস্ট আনলক করুন।"
              )}
            </p>
            <button
              className="premium-modal-button"
              onClick={() => (window.location.href = "/pricing")}
            >
              {getText("Go to Subscription Page", "সাবস্ক্রিপশন পেইজে যান")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hazard;
